import React, { FC } from 'react';

import { cn } from '../Utils/cnUtil';
import { AlarmChipSize } from './AlarmChipSize';

/**
 * Status pill for an alarm. Presentational only — the caller passes an already translated label so
 * the component stays free of i18n.
 */
const AlarmStatusChip: FC<AlarmStatusChipProps> = ({
  className,
  status,
  label,
  size = 'sm',
}: AlarmStatusChipProps) => {
  const isActive = status === 'ACTIVE';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full',
        'font-medium leading-5 ring-1 ring-inset',
        size === 'md' ? 'px-2.5 py-1 text-sm' : 'px-2 py-0.5 text-xs',
        isActive
          ? 'bg-red-50 text-red-700 ring-red-200'
          : 'bg-emerald-50 text-emerald-700 ring-emerald-200',
        className
      )}
      title={label}
    >
      <span
        className={cn(
          'h-1.5 w-1.5 shrink-0 rounded-full',
          isActive ? 'bg-red-500' : 'bg-emerald-500'
        )}
      />
      {label}
    </span>
  );
};

interface AlarmStatusChipProps {
  className?: string;
  status: 'ACTIVE' | 'INACTIVE';
  /** Already translated status text, e.g. "Active" / "Активен". */
  label: string;
  size?: AlarmChipSize;
}

export default AlarmStatusChip;
